var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1366_10239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20654 12.5054L11.8986 2.51746L14.4822 5.17985L4.78988 15.1675L2.20654 12.5054Z",
    fill: "#7257F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5897 4.03799L15.9588 3.65769C16.3038 3.30213 16.4938 2.82957 16.4938 2.32663C16.4938 1.82368 16.3038 1.35112 15.9588 0.995563C15.6137 0.640003 15.1549 0.443665 14.6668 0.443665C14.1788 0.443665 13.7202 0.639734 13.3749 0.995294L13.0059 1.3756L15.5897 4.03799Z",
    fill: "#7257F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90732 12.956L0.850814 16.2217C0.819494 16.3182 0.844028 16.425 0.913975 16.4968C0.963564 16.5479 1.03038 16.5756 1.0985 16.5756C1.12616 16.5756 1.15383 16.571 1.18097 16.5616L4.34972 15.4732L1.90732 12.956Z",
    fill: "#7257F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2681 2.13607L12.6374 1.75549L15.221 4.41789L14.8517 4.79846L12.2681 2.13607Z",
    fill: "#7257F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1366_10239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6558,
    height: 16.1333,
    fill: "white",
    transform: "translate(0.836914 0.444458)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.1f6b29ce646766ac9e151b0f3e572f9d.svg";
export { ForwardRef as ReactComponent };